import { Popover, Tooltip } from 'antd';
import MinusSvgComponent from 'assets/svg/Minus';
import PlusSvgComponent from 'assets/svg/Plus';
import React, { Dispatch, FC, SetStateAction, useState } from 'react';

interface Props {
    isExpanded: boolean;
    onClick: Function;
    title: string;
    titleClassName?: string;
    className?: string;
}

const ExpansionBar: FC<Props> = ({ title, isExpanded, onClick, titleClassName = '', className = '' }) => {
    const clickHandler = () => {
        onClick(!isExpanded);
    };
    return (
        <div
            onClick={clickHandler}
            className={`flex cursor-pointer rounded font-xs font-medium mb-4 justify-between items-center px-4 py-3 bg-bgBackground text-purpleFont ${className}`}
        >
            <p className={titleClassName}>{title}</p>
            {isExpanded ? (
                <Popover content="Collapse">
                    <span className="p-1">
                        <MinusSvgComponent />
                    </span>
                </Popover>
            ) : (
                <Popover content="Expand">
                    <span className="p-1">
                        <PlusSvgComponent />
                    </span>
                </Popover>
            )}
        </div>
    );
};

export default ExpansionBar;
